module.exports = __webpack_public_path__ + "img/zfb.b5fe80e3.png";